// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1ual4","ranges":"BmiRanges_ranges__sMwDt"};